import styleInject from '../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Link-module_link__Ly-e3{color:var(--control-accent-background);cursor:pointer;text-decoration:none}.Link-module_link__Ly-e3:hover{color:var(--control-accent-hover-background)}";
var style = {"link":"Link-module_link__Ly-e3"};
styleInject(css_248z);

export { style as default };
//# sourceMappingURL=Link.module.css.js.map
